/*  ==========================================================================
    EHOTELIER POP-UP
    Helper to load detailed informations from ehotelier inside a pop-up.

    Info:
    - mainly thought for rooms and offers
    - container needs class "eh-pop-up"
    - trigger needs class "eh-detail-link"
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import historyEvents from 'history-events';

// local imports
import * as vars from '../../globals/variables';
import * as utils from "../utils";

// import dynform config
import {initDynform} from "../../ehotelier/dynforms/init";

/*
 * EHOTELIER POP-UP
 */

// close pop-up function
function closePopUp() {
    vars.$body.removeClass('no-scroll');
    vars.$p_ehotelierPopUp.removeClass('bn-ehotelier-pop-up--open');
    setTimeout(function () {
        vars.$p_ehotelierPopUp.find('.eh-service').empty();
        vars.$p_ehotelierPopUp.find('.eh-service').removeClass('eh-service--ready');
        if(vars.$p_ehotelierPopUp.find('.eh-service').hasClass('slick-initialized')){
            vars.$p_ehotelierPopUp.find('.eh-service').slick('unslick');
        }
        vars.$p_ehotelierPopUp.find('.eh-service').append(vars.default_loader);
        vars.$p_ehotelierPopUp.find('.eh-service').append(vars.default_noEntries);
        vars.$p_ehotelierPopUp.find('.bn-ehotelier-pop-up__control-info').empty();
        vars.$p_ehotelierPopUp.find('.bn-ehotelier-pop-up__arrows').empty();
    }, 1000);
}

const popupOpen = () => document.getElementsByClassName('bn-ehotelier-pop-up--open')[0];

// service hook function
function serviceFuncHook(container,data) {

    // calculate offer min price and add it to record
    if (data.type === 'offer') {
        utils.ehotelierPrices.initEhotelierOfferMinPrice(data);
    }

    // calculate offer room prices and add it to record
    if (data.type === 'offer') {
        utils.ehotelierPrices.initEhotelierOfferRoomPrices(data);
    }

    // calculate room min price and add it to record
    if (data.type === 'room') {
        utils.ehotelierPrices.initEhotelierRoomMinPrice(data);
    }

    // resort items (selected item should be always at first position!)
    let selectedItem,
        selectedItemID = location.pathname.match(/(\d+)\/?$/i)[1];
    if (data.type === 'offer') {
        $.each(data.records, function(key, record) {
            if(record.id == selectedItemID) {
                selectedItem = record;
            }
        });
        data.records.splice($.inArray(selectedItem, data.records),1);
        data.records.unshift(selectedItem);
        //Toggle Image Button (Offers)
        let $body = $("body");
        $body.off();
        $body.on( "click", ".js-toggle-offerimages", function() {
            let $images = $('.bn-offer-box__images');
            $images.toggleClass('bn-hidden');
        });
    } else if (data.type === 'room') {
        $.each(data.records, function(key, record) {
            $.each(record.roomtypes, function(key, roomtype) {
                if(roomtype.id == selectedItemID) {
                    selectedItem = roomtype;
                }
            });
            record.roomtypes.splice($.inArray(selectedItem, record.roomtypes),1);
            record.roomtypes.unshift(selectedItem);
            //Toggle Image Button (Rooms)
            let $body = $("body");
            $body.off();
            $body.on( "click", ".js-toggle-roomimages", function() {
                let $images =  $('.bn-room-box__images');
                $images.toggleClass('bn-hidden');
            });
        });
    }

}

// service custom function
function serviceFuncCustom(container,data) {

    // magnific popup
    utils.mfp.initGallery(container);
    utils.mfp.initIframe(container);
    utils.mfp.initSingleImage(container);

    // initialize item slider
    let $itemSliderArrows = $(container).parent().find('.bn-ehotelier-pop-up__arrows'),
        $itemSliderContainer = $(container),
        itemSliderOverrides = {
            adaptiveHeight: true,
            appendArrows: $itemSliderArrows,
            autoplay: false,
            dots: false,
            dynamicHeight: true,
            fade: false,
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2,
            touchMove: false
        };
    $itemSliderContainer.one('init', function(){
        if (data.type === 'offer') {
            $(container).parent().find('.bn-ehotelier-pop-up__control-info').append(vars.ts.text.changeOffer);
        } else if (data.type === 'room') {
            $(container).parent().find('.bn-ehotelier-pop-up__control-info').append(vars.ts.text.changeRoom);
        }
    });
    utils.slickCarousel.initSingleSlider($itemSliderContainer, itemSliderOverrides);

    const getCode = (code, elem) => {
        if ((code in elem.dataset && elem.dataset !== '')) {
            if (data.type === 'offer') {
                return elem.dataset[code];
            } else if (data.type === 'room') {
                return elem.dataset[code].split(",");
            }
        }
        return [];
    };

    const langID = document.body.dataset['langId'];
    const hotelID = document.body.dataset['ehHid'];
    const formElement = () =>
        container[0].querySelectorAll('.slick-current .bn_dynForm.bn_request')[0] ||
        container[0].querySelectorAll('.bn_request')[0];
    const goToSlide = (slide) => {
        let index = slide.closest('.slick-slide').dataset['slickIndex'];
        vars.$p_ehotelierPopUp.find('.eh-service').slick('slickGoTo', index);
    };
    const triggerHistory = (event) => {
        if (popupOpen()) {
            if (event && !utils.general.isEmpty(event.state)) {
                if (data.type === 'offer') {
                    goToSlide(document.querySelectorAll("[id^='bn_request-'].bn_dynForm.bn_request[data-offer_id='" + event.state.offer_id + "']")[0]);
                } else if (data.type === 'room') {
                    goToSlide(document.querySelectorAll("[id^='bn_request-'].bn_dynForm.bn_request[data-room_code='" + event.state.room_code + "']")[0]);
                }
            } else {
                window.removeEventListener('onpopstate', triggerHistory, false);
                window.history.pushState({}, '', window.location.pathname);
                utils.general.simulateClick(document.getElementsByClassName('bn-ehotelier-pop-up__close')[0]);
            }
        }
    };

    if (data.type === 'offer') {
        const currentOffer = () => getCode('offer_id', formElement());
        const pageID = vars.ts.pids.detail_offer;

        initDynform();
        window.onpopstate = triggerHistory;
        $('.bn-ehotelier-pop-up--open').find('.bn-ehotelier-pop-up__arrows > .bn-arrows__arrow').on('click', function() {
            const ehotOfferTitle = 'offer-' + currentOffer() + '-' + hotelID + '-' + langID;
            $.ajax({
                method: 'GET',
                url: '/?type=1001&page=' + pageID + '&language=' + langID + '&offer=' + ehotOfferTitle
            }).done(function (data) {
                window.history.pushState({offer_id: currentOffer()}, null, data);
            });
            initDynform();
        });
        window.history.pushState({offer_id: currentOffer()}, null, window.location.pathname);
    }

    else if (data.type === 'room') {
        const currentRoom = () => getCode('room_code', formElement());
        const roomLink = () => {
            let room_code = currentRoom()[0];
            let versionText = $('.eh-service section:eq(0)').attr('id').split("-");
            let version = '';
            //Check if Version is set (v*)
            if(versionText[3].includes("v")){
                version = versionText[3] + '-';
            }
            let room_element = document.getElementById('bn-room-box-' + version + '' + room_code);
            return room_element.getElementsByClassName('eh-detail-link')[0].getAttribute('href');
        };

        initDynform();
        window.onpopstate = triggerHistory;
        $('.bn-ehotelier-pop-up--open').find('.bn-ehotelier-pop-up__arrows > .bn-arrows__arrow').on('click', function() {
            window.history.pushState({room_code: currentRoom()}, null, roomLink());
            initDynform();
        });
        window.history.pushState({room_code: currentRoom()}, null, window.location.pathname);
    }

    // scroll to top of container if user slides to next or previous item
    $itemSliderArrows.on('click', '.bn-arrows__arrow', function (e) {
        $itemSliderContainer.animate({
            scrollTop: 0
        }, 0);
    });

    // initialize image slider
    $(container).find('.eh-item').each(function () {
        let $imageSliderArrows = $(this).find('.slick-arrows'),
            $imageSliderContainer = $(this).find('.eh-item__slider'),
            $imageSliderDots = $(this).find('.slick-dots'),
            imageSliderOverrides = {
                appendArrows: $imageSliderArrows,
                appendDots: $imageSliderDots,
                nextArrow: vars.slick_nextArrowV2,
                pauseOnHover: true,
                prevArrow: vars.slick_prevArrowV2
            };
        utils.slickCarousel.initSingleSlider($imageSliderContainer, imageSliderOverrides);
    });

    $itemSliderArrows.on('click', '.bn-arrows__arrow', function (e) {
        $('.eh-item__slider').each(function () {
            console.log($(this));
            $(this).slick('slickGoTo', 0);
        });
    });


    // create room price list, but first check if slick slider is in use (if it is so then load only this price list which is in current slide!)
    if (data.type === 'room') {
        $(container).find('.eh-item .eh-rates').each(function () {
            let priceListContainer = $(this);
            if ($(container).hasClass('slick-slider')) {
                $(priceListContainer).on('inview', function() {
                    utils.ehotelierPrices.initEhotelierRoomPriceList(priceListContainer);

                });
            } else {
                $(priceListContainer).one('inview', function() {
                    utils.ehotelierPrices.initEhotelierRoomPriceList(priceListContainer);
                });
            }
        });
    }

}

// initialization
export function initEhotelierPopUp($element,serviceDefaultConfig) {
    if ($element.hasClass('eh-pop-up')) {
        let defaultUrl = location.pathname;

        // open pop-up (only on desktop, not mobile)
        $element.on('click', '.eh-detail-link', function (e) {
            if (!$(vars.$body).hasClass('mobile-view')) {
                e.preventDefault();
                vars.$body.addClass('no-scroll');
                vars.$p_ehotelierPopUp.addClass('bn-ehotelier-pop-up--open');

                // change url in browser address bar for history
                let detailUrl = $(this).attr('href');
                history.replaceState({}, '', detailUrl);

                // ehotelier service initialization
                let serviceContainer = vars.$p_ehotelierPopUp.find('.eh-service'),
                    serviceConfig = {
                        addParams: {},
                        container: serviceContainer,
                        funcCustom: serviceFuncCustom,
                        funcHook: serviceFuncHook,
                        subtype: 'pop-up',
                        type: serviceDefaultConfig.type
                    };
                if (serviceConfig.type === 'offer' || serviceConfig.type === 'room') {
                    utils.ehotelierLoader.initEhotlierService(serviceConfig);
                } else {
                    $(serviceContainer).find('.bn-loader').addClass('hidden');
                    $(serviceContainer).find('.bn-no-result').removeClass('hidden');
                }

            }
        });

        // close and reset pop-up via close icon
        vars.$p_ehotelierPopUp.on('click', '.bn-ehotelier-pop-up__close', function () {
            history.replaceState({}, '', defaultUrl);
            closePopUp();
        });

        // close and reset pop-up by clicking outside the pop-up
        vars.$p_ehotelierPopUp.on('click', '.bn-ehotelier-pop-up__overlay', function () {
            history.replaceState({}, '', defaultUrl);
            closePopUp();
        });

        // close and reset pop-up on history change (needs "history-events.js")
        if (historyEvents.isHistorySupported()) {
            window.addEventListener('changestate', function(e) {
                if (location.pathname === defaultUrl) {
                    closePopUp();
                }
            });
        }

    }
}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/ehotelier-pop-up.js